// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Checkbox from 'material-ui/Checkbox'


class EditProfile extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      customer:{
        "name": '',
        "customer_type": '',
        "date_of_birth": moment().format("YYYY-MM-DD"),
        "gender": '',
        "email": '',
        "mobile_no": '',
        "jersey_size": '',
        "father_name": '',
        "father_number": '',
        "mother_name": '',
        "mother_number": '',
        "address": '',
        "school": '',
        "apartment": '',
        "level": [],
        "game_level": '',
        "selected_game":1,
        
      },
      games: [],
      game:1

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleSkill = this.handleSkill.bind(this);
  }

  handleStartDate(date){
    var new_selected_one =  Object.assign({}, this.state.customer);
    new_selected_one['date_of_birth'] = date
    this.setState({customer: new_selected_one});
  }

  componentDidMount() {
    this.getGames();
    this.getCustomerDetails();
  }

  getGames(){
    const url = `${getLocationOrigin()}/customer_list/get_all_games/`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ games: data.result}))
       .catch(error => error);
  }
  
  getCustomerDetails(){
    const url = `${getLocationOrigin()}/customer_list/`+this.state.id+`/edit_customer/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data =>this.setState({ customer: data.customer},()=>{
          console.log('cus details..')
          console.log(data)
          console.log(data.customer.date_of_birth)
          console.log(this.state.date_of_birth)
          {/*for(var i=0;i<this.state.customer.level.length;i++){
                    if(this.state.customer.level[i].game_id){
                          data['selected_game'] = this.state.customer.level[i].game_id
                          this.setState({customer:data});
                        }
                  }*/}
          }))       
       .catch(error => error);

  }

  postEditedMatch(data, props,game) {
    console.log('save data..')
    console.log(data.date_of_birth);
    console.log(game)
    if(!data.date_of_birth){
      var date = undefined;
    }
    else{
      var date = moment(data.date_of_birth).format("YYYY-MM-DD");
    }
    if(data.customer_type == 'Adult'){
      var customer_type = 1;
    }
    else if(data.customer_type == 'Child'){
      var customer_type = 2;
    }

    const url = `${getLocationOrigin()}/customer_list/`+this.state.id+`/edit_customer/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'name': data.name,
                                        'mobile_no': data.mobile_no,
                                        'email': data.email,
                                        'date_of_birth': date,
                                        'gender': data.gender,
                                        'customer_type': customer_type,
                                        'father_name': data.father_name,
                                        'father_number': data.father_number,
                                        'mother_name': data.mother_name,
                                        'mother_number': data.mother_number,
                                        'jersey_size': data.jersey_size,
                                        'address': data.address,
                                        'school': data.school,
                                        'apartment':data.apartment,
                                        'level': data.level,
                                        'game_id':game  });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){
          alert(response.message)
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  handleSkill(event){
    console.log('handleSkill...')
    console.log(event.target.name)
    console.log(event.target.value)
    const name = event.target.name;
    var new_Skill = Object.assign({}, this.state.customer);
    if(name == 'game'){
      new_Skill['level'][0].game_id = event.target.value;

      new_Skill['level'][0].game_level = 1;
      this.setState({game:event.target.value});


    }
    else{

      new_Skill['level'][0].game_level = event.target.value;
      new_Skill['level'][0].game_id = 1;

    }
    this.setState({customer: new_Skill});
        console.log(new_Skill['level'])

  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.customer);
    new_selected_one[name] = event.target.value
    this.setState({customer: new_selected_one});

  }

  handleSubmit(event) {
    console.log(this.state.customer);
    event.preventDefault();
    this.postEditedMatch(this.state.customer, this.props,this.state.game);
  }

  render() {
    console.log("here");
    const levels = ['Beginner','Intermediate','Advanced']
    console.log(this.state.customer);
    console.log(this.state.customer.date_of_birth)
    var cust_type = ''
    if (this.state.customer.customer){
      cust_type = this.state.customer.customer.customer_type
    }
    else{
      cust_type = this.state.customer_type
    }

    if(this.state.customer.date_of_birth == null){
      var DOB = moment()      
    }
    else{
      var DOB = this.state.customer.date_of_birth
    }
    return(
      <div style={styles.container}>
        <div className="row col-md-10 table-bordered" style={styles.table}>
            
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Edit Profile</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Name
              </div>
              <div className="col-md-6 input-group" style={styles.item_body}>
                <input type="text" name="name" className="form-control"
                  placeholder="Name " value={this.state.customer.name} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Mobile
              </div>
              <div className="col-md-6 input-group" style={styles.item_body}>
                <input type="tel" name="mobile_no" readOnly= {true} className="form-control" size="10"
                  placeholder="Mobile" value={this.state.customer.mobile_no} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Email
              </div>
              <div className="col-md-6 input-group" style={styles.item_body}>
                <input type="text" name="email" className="form-control"
                  placeholder="Email" value={this.state.customer.email}  onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Date of Birth
              </div>
              <DatePicker selected={moment(DOB)} style={{zIndex:2}} onChange={this.handleStartDate}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Type
              </div>
              <select name="customer_type" className="col-md-6" style={{padding: '6px ',width:'60%'}} value={this.state.customer.customer_type}
                onChange={this.handleChange}> 
                  <option value="Adult">Adult</option>
                  <option value="Child">Child</option>
              }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Gender
              </div>
              <select name="gender" className="col-md-6" style={{padding: '6px ',width:'60%'}}  value={this.state.customer.gender}
                onChange={this.handleChange}>
                  <option value="M">M</option>
                  <option value="F">F</option>
              }
              </select>
            </div>
           
           {
            (cust_type != 'Adult') ?
            <div>
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Fathers Name
                </div>
                <div className="col-md-6 input-group" style={{padding: '6px ',width:'60%',zIndex:'0'}}>
                  <input type="text" name="father_name" className="form-control"
                    placeholder="Name " value={this.state.customer.father_name} onChange={this.handleChange}/>
                </div>
              </div>
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Fathers No
                </div>
                <div className="col-md-6 input-group" style={{padding: '6px ',width:'60%',zIndex:'0'}}>
                  <input type="tel" name="father_number" className="form-control"
                    placeholder="Name " value={this.state.customer.father_number} onChange={this.handleChange}/>
                </div>
              </div>
               <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Mother's Name
                </div>
                <div className="col-md-6 input-group" style={styles.item_body}>
                  <input type="text" name="mother_name" className="form-control"
                    placeholder="Name " value={this.state.customer.mother_name} onChange={this.handleChange}/>
                </div>
              </div>
               <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Mother's No
                </div>
                <div className="col-md-6 input-group" style={styles.item_body}>
                  <input type="tel" name="mother_number" className="form-control"
                    placeholder="Name " value={this.state.customer.mother_number} onChange={this.handleChange}/>
                </div>
              </div>
               <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  School
                </div>
                <div className="col-md-6 input-group" style={styles.item_body}>
                  <input type="text" name="school" className="form-control"
                    placeholder="Name " value={this.state.customer.school} onChange={this.handleChange}/>
                </div>
              </div>
            </div>
            :
            <div></div>}
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Residential Address
              </div>
              <div className="col-md-6 input-group" style={{padding: '6px ',width:'60%',zIndex:'0'}}>
                <input type="text" name="address" className="form-control"
                  placeholder="Name " value={this.state.customer.address} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Game
              </div>
              <select name="game" className="col-md-6" style={styles.item_body}
                onChange={this.handleSkill} value={this.state.value} value={this.state.customer.selected_game}> 
                  {
                    this.state.games.map((game,index)=>(
                      <option key={game.pk} value={game.pk}>{game.name}</option>
                    ))
                  }
              }
              </select>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Gamelevel
              </div>
              <select name="level" className="col-md-6" style={styles.item_body}
                onChange={this.handleSkill}> 
                  <option value>-------</option>
                  <option value="Beginner">Beginner</option>
                  <option value="Intermediate">Intermediate</option>
                  <option value="Advanced">Advanced</option>
              }
              </select>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Apartment Name
              </div>
              <div className="col-md-6 input-group" style={styles.item_body}>
                <input type="text" name="apartment" className="form-control"
                  placeholder="Name " value={this.state.customer.apartment} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Jersey Size
              </div>
              <div className="col-md-6 input-group" style={styles.item_body}>
                <input type="tel" name="jersey_size" className="form-control"
                  placeholder="Name " value={this.state.customer.jersey_size} onChange={this.handleChange}/>
              </div>
            </div>

           
            
            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
         
         

        </div>
      </div>
    );
  }
}

export default EditProfile;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editProfile/index.js